import React, { Component, Fragment } from "react";
import Breadcrumbs from "../../shared/Breadcrumbs";
import { StaqEventsRoute } from "../../routing/IndividualRoutes";

export class StaqEventsPage extends Component {
  render() {
    return (
      <Fragment>
        <Breadcrumbs />
        <StaqEventsRoute />
      </Fragment>
    );
  }
}
